export const GET_INSURANCEPAGE_BY_ID_METHOD = (id: any, preview: boolean) => `
  query {
    insurancepage(id: "${id}", preview: ${preview}) {
    sys {
        id
      }
      linkedFrom {
        pageCollection(limit: 1) {
          items {
            sys {
              id
            }
          }
        }
      }
      insuranceName
      heading
      subheader
      preamble
      uspHeading
      uspar
      topImage
      topImageText
      heroContentAreaCollection {
        items {
          __typename
          ... on Link {
            sys {
              id
            }
          }
        }
      }
      personalizedMessageFallback {
        __typename
        ...on RestrictedRichTextBlock{sys{id}}
    }
    personalizedMessageVariantsCollection {
        items {
          __typename
          ...on RestrictedRichTextBlock{sys{id} audienceCollection{items{audianceId}}}
        }
    }
		linkToInsuranceClaimPage{
      sys {
          id
        }
        slug
        content {
          __typename
        }
      }
      insuranceClaimButtonText
      fallbackUspHeading
      availableForAudiencesCollection{
        items{
          name
          audianceId
          sectorId
          sectorGroupValue
        }
      }
      ivMainImage
      changeSectorLabel
      mainAreaCollection{
        items{
            __typename
          ...on RichTextBlock{sys{id}}
          ...on AccordionBlock{sys{id}}
          ...on FileBlock{sys{id}}
          ...on InformationBlock{sys{id}}
          ...on TeaserBlock{sys{id}}
          ...on Link{sys{id}}
          ...on Sectionblock{sys{id}}
          ...on Videoblock{sys{id}}
          ...on TableBlock {sys{id}}
          ...on Page{sys{id}}
          ...on PersonalizationBlock{sys{id}}
          ...on FaqListBlock {sys {id}}
          ...on ImageBlock {sys {id}}
          ...on FileListBlock {sys{id}}
          ... on PaymentDaysBlock {sys {id}}
          ... on BannerBlock {sys {id}}
          ... on ContactUsBlock {
            sys {
              id
            }
          }
          ... on LinkTeaserBlock {sys {id}}
          }
      }
      relatedContentHeading
      relatedContentSmallImages
      relatedContentCollection {
        items {
          __typename
          ...on TeaserBlock{sys{id}}
          ...on Page{sys{id}}
        }
      }
    }
  }
`;
